import useConfig from "@/hooks/useConfig";
import type { V2PageKey } from "@/v2/lib/flags";

export function useV2Flag(page: V2PageKey): boolean {
  return useConfig()?.v2?.[page] === true;
}
